import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_CONFIG = {
  event_name: 'R77 Challenge 7.0',
  tagline: 'Você e sua dupla em 21 dias de desafio para se tornarem os melhores da sua categoria.',
  duration_text: '21 dias',
  price: 60.0,
  categories: ['Iniciante', 'Intermediário', 'Avançado'],
  registrations_open: true,
  event_year: '2026',
};

export const useEventConfig = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/event-config`)
      .then((res) => {
        if (mounted) setConfig({ ...DEFAULT_CONFIG, ...res.data });
      })
      .catch(() => {})
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { config, loading };
};

export default useEventConfig;
